import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type EmissionFactor, type Footprint, type FootprintSub, type FpCalculation, type FpCalculationField, type KpiValue } from 'types/models';

export interface FootprintsState extends EntityState<Footprint>, ActiveState {
   activeCalculation?: FpCalculation['id'] | null;
   activeCalculationField?: FpCalculationField['id'] | null;
   selectedEmissionFactor?: EmissionFactor | null;
   previousSelectedEmissionFactor?: EmissionFactor | null;
   activeSub?: FootprintSub['slug'] | null;
   loadSubCalculations: boolean;
   sums: KpiValue[];
   allFootprints: Footprint[];
   reportFootprints: Footprint[];
   scopeSums: any[];
   isLoadingSubCalculations: boolean;
}

const store = createEntityStore<FootprintsState>(
   {
      activeCalculation: undefined,
      activeCalculationField: undefined,
      selectedEmissionFactor: undefined,
      previousSelectedEmissionFactor: undefined,
      activeSub: undefined,
      loadSubCalculations: false,
      sums: [],
      allFootprints: [],
      reportFootprints: [],
      scopeSums: [],
      isLoadingSubCalculations: false,
   },
   { resettable: true, name: 'emission/footprints' }
);

export default store;
